import { Clock } from '../../../components/ui/icons';
import { countdownDetailed } from '../../../lib/format';
import { cn } from '../../../lib/cn';
import { URGENT_COUNTDOWN_CHIP } from './constants';

export function CountdownChip({ kickoffAt, now, urgent }: { kickoffAt: number; now: number; urgent: boolean }) {
  return (
    <span
      className={cn(
        'num inline-flex items-center gap-[5px] rounded-[8px] text-[11.5px] font-extrabold tracking-[-0.01em]',
        urgent
          ? cn('border px-[9px] py-1', URGENT_COUNTDOWN_CHIP)
          : 'px-0.5 py-1 font-bold text-[#A0A0A8]'
      )}
    >
      <Clock width={11} height={11} strokeWidth={2.4} className={urgent ? 'text-[#F0B34A]' : 'text-[#A0A0A8]'} />
      {countdownDetailed(kickoffAt, now)}
    </span>
  );
}
